<template>
  <pop-box
    ref="myPopbox"
    class="upload-popbox"
    :hasNotButton="true"
    :title="title"
    @closeDialog="$emit('close')"
    :width="960"
  >
    <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目名称" prop="projectName">
            <el-input v-model="formData.projectName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目类型" prop="projectType">
            <el-select
              clearable
              v-model="formData.projectType"
              placeholder="请选择"
            >
              <el-option
                v-for="item in projectTypeList"
                :key="item.dicId"
                :label="item.dicName"
                :value="item.dicId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="所在省市区" prop="location">
          <el-cascader
            :options="areaSelectData"
            class="full-width"
            size="large"
            @change="changeArea"
            v-model="selectedArea"
            placeholder="请选择您所在的城市"
          />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="项目地址" prop="projectAddr">
          <el-input v-model="formData.projectAddr"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="检测协议(合同)">
            <el-upload
              style="margin-left: 10px"
              class="upload-demo"
              accept=".zip,.rar,.png,.jpg,.jpeg,.bmp,.pdf,.doc,.docx"
              action=""
            >
              <el-button size="small" type="primary" disabled>上传</el-button>
              <div slot="tip" class="el-upload__tip tips">
                支持的文件格式有:zip, rar, png, jpg, jpeg, bmp, pdf, doc, docx
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="检测方案">
            <el-upload
              style="margin-left: 10px"
              class="upload-demo"
              accept=".zip,.rar,.png,.jpg,.jpeg,.bmp,.pdf,.doc,.docx"
              action=""
            >
              <el-button size="small" type="primary" disabled>上传</el-button>
              <div slot="tip" class="el-upload__tip tips">
                支持的文件格式有:zip, rar, png, jpg, jpeg, bmp, pdf, doc, docx
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="协议(合同)编号">
            <el-input v-model="formData.agreementNo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="防雷类别" prop="preventThunderType">
            <el-select
              clearable
              multiple
              v-model="choosePreventThunder"
              placeholder="请选择"
              @change="onChoosePreventThunder"
            >
              <el-option
                v-for="item in preventThunderTypeList"
                :key="item.dicId"
                :label="item.dicName"
                :value="item.dicId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检测类型" prop="checkType">
            <el-select
              clearable
              v-model="formData.checkType"
              placeholder="请选择"
            >
              <el-option
                v-for="item in checkTypeList"
                :key="item.dicId"
                :label="item.dicName"
                :value="item.dicId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="被检对象类型" prop="checkObjType">
            <el-select
              clearable
              v-model="formData.checkObjType"
              placeholder="请选择"
            >
              <el-option
                v-for="item in checkObjTypeList"
                :key="item.dicId"
                :label="item.dicName"
                :value="item.dicId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="被检对象名称" prop="checkObjName">
            <el-input v-model="formData.checkObjName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检测单位证件号" prop="checkObjNo">
            <el-input v-model="formData.checkObjNo"></el-input>
            <div class="tips">
              类型是单位（公司）填写统一社会信用代码，个人场所填写身份证
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检测报告编号" prop="checkReportNo">
            <el-input v-model="formData.checkReportNo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="被检建筑物数量" prop="checkBuildingNum">
            <el-input v-model="formData.checkBuildingNum"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="编制人员" prop="operatorPerson">
            <el-select
              clearable
              v-model="formData.operatorPerson"
              placeholder="请选择"
            >
              <el-option
                v-for="item in employeesList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检测人员" prop="checkPerson">
            <el-select
              clearable
              multiple
              v-model="chooseCheckPerson"
              placeholder="请选择"
              @change="onChooseCheckPerson"
            >
              <el-option
                v-for="item in employeesList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="复核人员" prop="reviewPerson">
            <el-select
              clearable
              v-model="formData.reviewPerson"
              placeholder="请选择"
            >
              <el-option
                v-for="item in employeesList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检测日期" prop="checkDate">
            <el-date-picker
              v-model="checkDate"
              @change="dateChange"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
            <div class="tips">
              如果存在多天检测时间，以最后一天检测完成日期为准
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="批准人员" prop="approvePerson">
            <el-select
              clearable
              v-model="formData.approvePerson"
              placeholder="请选择"
            >
              <el-option
                v-for="item in employeesList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="检测结论" prop="checkConclusion">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入"
            v-model="formData.checkConclusion"
          >
          </el-input>
        </el-form-item>
      </el-row>
    </el-form>
    <div class="dialog-footer btn-wrapper">
      <el-button class="btnx-normal btn-blue" @click="onSave">保存</el-button>
      <el-button class="btnx-normal btn-gray" @click="onClose">关闭</el-button>
    </div>
  </pop-box>
</template>
<script>
import { getAction, getDictList } from "@/service/http/api";
import { regionData } from "element-china-area-data";
import editMixin from "@/mixin/editModal";
import filters from "@/service/filters";
import formRules from "@/service/formRules"
export default {
  name: "Edit",
  props: ["rowId", "title", "mode"],
  mixins: [editMixin],
  data() {
    let validateNO = (rule, value, callback) => {
      if (!value) {
        callback();
        return;
      }
      let reg = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$|(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      setTimeout(() => {
        if (!reg.test(value)) {
          callback(new Error('证件号码有误'))
        } else {
          callback()
        }
      }, 200)
    }
    return {
      formData: {
        id: null,
        projectName: null,
        projectType: null,
        location: null,
        projectAddr: null,
        agreementNo: null,
        preventThunderType: null,
        checkType: null,
        checkObjType: null,
        checkObjName: null,
        checkObjNo: null,
        checkReportNo: null,
        checkBuildingNum: localStorage.getItem('employeeId'),
        operatorPerson: null,
        checkPerson: null,
        reviewPerson: null,
        checkDate: null,
        approvePerson: null,
        checkConclusion: null,
        createPerson: null,
      },
      rules: {
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        projectType: [
          { required: true, message: "请选择项目类型", trigger: "change" },
        ],
        location: [
          { required: true, message: "请选择所在省市区", trigger: "change" },
        ],
        projectAddr: [
          { required: true, message: "请输入项目地址", trigger: "blur" },
        ],
        preventThunderType: [
          { required: true, message: "请选择防雷类别", trigger: "change" },
        ],
        checkType: [
          { required: true, message: "请选择检测类型", trigger: "change" },
        ],
        checkObjType: [
          { required: true, message: "请选择被检对象类型", trigger: "change" },
        ],
        checkObjName: [
          { required: true, message: "请输入被检对象名称", trigger: "blur" },
        ],
        checkObjNo: [
          { required: true, message: "请输入被检对象证件号", trigger: "blur" },
          {validator: validateNO, trigger: 'blur', transform(value) {
              return value ? value : null;
            }}
        ],
        checkReportNo: [
          { required: true, message: "请输入检测报告编号", trigger: "blur" },
        ],
        checkBuildingNum: [
          { required: true, message: "请输入被检建筑物数量", trigger: "blur" },
          formRules.intege
        ],
        checkPerson: [
          { required: true, message: "请选择检测人员", trigger: "change" },
        ],
        reviewPerson: [
          { required: true, message: "请选择复核人员", trigger: "change" },
        ],
        checkDate: [
          { required: true, message: "请选择检测日期", trigger: "change" },
        ],
        approvePerson: [
          { required: true, message: "请选择批准人员", trigger: "change" },
        ],
        checkConclusion: [
          { required: true, message: "请输入检测结论", trigger: "blur" },
        ],
      },
      projectTypeList: [],
      areaSelectData: regionData, // options绑定的数据就是引入的 provinceAndCityData
      selectedArea: [], // 地区选择参数，['省区域码', '市区域码']
      checkDate: null,
      preventThunderTypeList: [],
      checkTypeList: [],
      checkObjTypeList: [],
      employeesList: [],
      choosePreventThunder: null,
      chooseCheckPerson: null,
      url: {
        add: "/check/checkProject/add",
        edit: "/check/checkProject/edit",
        query: "/check/checkProject/queryById",
        employees: "/check/checkProject/queryEmployees",
      },
    };
  },
  methods: {
    changeArea() {
      this.formData.location = this.selectedArea.join(",");
    },
    dateChange() {
      this.formData.checkDate = filters.formatDate(this.checkDate);
    },
    init() {
      if (this.mode === "edit") {
        this.selectedArea = this.formData.location.split(",");
        this.checkDate = this.formData.checkDate;
        this.choosePreventThunder = this.formData.preventThunderType.split(",");
        this.chooseCheckPerson = this.formData.checkPerson.split(",");
      }
    },
    async getInitData() {
      this.formData.createPerson = localStorage.getItem("userKey"); //ww 添加用户id
      this.projectTypeList = await getDictList(1);
      this.preventThunderTypeList = await getDictList(2);
      this.checkTypeList = await getDictList(3);
      this.checkObjTypeList = await getDictList(4);
      getAction(this.url.employees, { pageNum: 1, pageSize: 1000 }).then(
        (res) => {
          if (res.code === 200) {
            this.employeesList = res.data.records;
          }
        }
      );
    },
    onChoosePreventThunder() {
      this.formData.preventThunderType = this.choosePreventThunder.join(",");
      //2022-2-24 ww 存放多选防雷类别名称 start
      var typeName = "";
      this.preventThunderTypeList.forEach((item) => {
        if (
          this.choosePreventThunder != null &&
          this.choosePreventThunder.indexOf(item.dicId) >= 0
        ) {
          typeName += item.dicName + ",";
        }
      });
      this.formData.preTypeName = typeName.substring(
        0,
        typeName.lastIndexOf(",")
      );
      //2022-2-24 ww 存放多选防雷类别名称 end
    },
    onChooseCheckPerson() {
      this.formData.checkPerson = this.chooseCheckPerson.join(",");
      //2022-2-24 ww 存放多选点检测人员名称 start
      var personName = "";
      this.employeesList.forEach((item) => {
        if (
          this.chooseCheckPerson != null &&
          this.chooseCheckPerson.indexOf(item.id) >= 0
        ) {
          personName += item.name + ",";
        }
      });
      this.formData.checkPersonName = personName.substring(
        0,
        personName.lastIndexOf(",")
      );
      //2022-2-24 ww 存放多选点检测人员名称 end
    },
  },
  created() {
    this.getInitData();
  },
};
</script>

<style lang="scss" scoped>
.img-item {
  margin: 20px 40px;
  float: left;
  position: relative;
  width: 300px;
  p {
    line-height: 30px;
    color: #0d74fe;
  }
  .left,
  .right {
    position: absolute;
    top: 0;
    width: 30px;
    height: 300px;
    background: #ffffff;
  }
  .left {
    left: 0;
  }
  .right {
    right: 0;
  }
}
.img-item img {
  width: 240px;
  height: 300px;
}
.tips {
  color: #3883fe;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/detect_subject_management/edit.vue